// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3b9kN","title":"Header_title__1qWe7","left":"Header_left__3kfMd","clinicName":"Header_clinicName__Yf6My"};